// extracted by mini-css-extract-plugin
export var content = "_lg-1";
export var fullScreen = "_lg-0";